import { useMutation } from 'react-query';

import { updateActivityCodeAlias as mutationFn } from 'api/endPoints/updateActivityCodeAlias';

export const useMutationEditAlias = () => {
    return useMutation<any, QueryError, EditAliasProps>((params) => mutationFn(params));
};

interface EditAliasProps {
    alias: string;
    id: number;
}
